<template>
  <div>
    <div
      class="row top-buttons"
      v-if="this.options !== undefined && (this.options.getTopRightButtons || this.options.getTopLeftButtons)"
    >
      <div class="col text-right" v-if="this.options.getTopRightButtons">
        <component
          :entity="params.entity"
          @toggleSearchRow="onToggleSearchRow"
          @onFetchList="onFetchEntityListRequested"
          @onToggleHeaderForms="onToggleHeaderForms"
          v-for="(button,index) in options.getTopRightButtons()"
          :key="index"
          :is="button.component"
          :params="button.params"
          :data="selectedRows"
        />
      </div>
      <div class="col text-left" v-if="this.options.getTopLeftButtons">
        <component
          :entity="params.entity"
          @toggleSearchRow="onToggleSearchRow"
          @onFetchList="onFetchEntityListRequested"
          @onToggleHeaderForms="onToggleHeaderForms"
          v-for="(button,index) in options.getTopLeftButtons()"
          :key="index"
          :is="button.component"
          :params="button.params"
          :data="selectedRows"
        />
      </div>
    </div>
    <br>
    <div class="row search-row" ref="searchRow" style="display: none">
      <input
        ref="tableSearchInput"
        type="text"
        @input="onTableSearchInputChanged"
        class="form-control"
        placeholder="جستجو در جدول"
      >
    </div>
    <br>
    <div class="row" v-if="isLoading">
      <Preloader/>
    </div>
    <div v-else>
      <div class="row">
        <div class="vs-table" style="width: 100%;">
          <vs-table-header-row
            @onCreateHeaderActionClicked="onCreateHeaderActionClicked"
            ref="headerFormsRow"
            class="d-flex flex-fill"
            v-if="getOptionValue('hasActionsInHeader') && getOptionValue('createActionPosition') === 'top'"
            @dataChanged="onSearchInputDataChanged"
            :headers="params.headers"
            :options="options"
            :optionDefaults="optionDefaults"
            :mode="getOptionValue('headerActionsMode')"
            @onCreate="onCreateEntityRequested"
          />
          <vs-table-header-row
            class="d-flex flex-fill"
            :headers="params.headers"
            :options="options"
            :optionDefaults="optionDefaults"
            :mode="'view'"
            v-if="getOptionValue('createActionPosition') === 'top'"
          ></vs-table-header-row>
          <div
            class="vs-table-content-container"
            :style="{'height': getOptionValue('tableHeight'), 'overflow-y': getOptionValue('tableHeight') === null ? null : 'scroll'}"
          >
            <vs-table-row
              v-for="(listItem, listIndex) in list.data"
              :key="listIndex"
              :row="listItem"
              :rowIndex="list.data.length - listIndex"
              :headers="params.headers"
              :options="options"
              :show-paste="myshowPaste"
              :optionDefaults="optionDefaults"
              :entity="params.entity"
              @rowClicked="onRowClickedHandler"
              @rowDoubleClicked="onRowDoubleClickedHandler"
              @onFetchList="onFetchEntityListRequested"
              @onDelete="onDeleteEntityRequested"
              @onEditClicked="onEditClickedHandler"
              @onPrintClicked="onPrintClickedHandler"
              @onPasteClicked="onPasteClickedHandler"
              @onUpdateEntityRequested="onUpdateEntityRequested"
            />
          </div>
          <h5
            class="text-center no-data-note"
            v-if="list.data === undefined || list.data.length <= 0"
          >داده ای وجود ندارد.</h5>
          <vs-table-header-row
            :class="{'top-border-for-bottom-forms': getOptionValue('createActionPosition') === 'bottom'}"
            class="d-flex flex-fill"
            :headers="params.headers"
            :options="options"
            :optionDefaults="optionDefaults"
            :mode="'view'"
            v-if="getOptionValue('createActionPosition') === 'bottom'"
          ></vs-table-header-row>
          <vs-table-header-row
            @onCreateHeaderActionClicked="onCreateHeaderActionClicked"
            ref="headerFormsRow"
            class="d-flex flex-fill"
            v-if="getOptionValue('hasActionsInHeader') && getOptionValue('createActionPosition') === 'bottom'"
            @dataChanged="onSearchInputDataChanged"
            :headers="params.headers"
            :options="options"
            :optionDefaults="optionDefaults"
            :mode="getOptionValue('headerActionsMode')"
            @onCreate="onCreateEntityRequested"
          />
        </div>
      </div>
      <br>


      <div
        v-if="list.data !== undefined && list.data.length > 0 && (list.count / pagination.pageSize) > 1"
        class="row d-flex justify-content-center"
      >
        <!--<b-pagination
          align="center"
          @input="onPaginationChange"
          :total-rows="list.count"
          :per-page="pagination.pageSize"
        ></b-pagination>-->
        <b-pagination
          align="center"
          v-model="currentPage"
          :total-rows="list.count"
          :per-page="pagination.pageSize"
          aria-controls="my-table"
          @input="onPaginationChange"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import VsTableRow from "./VsTableRow.vue";
  import VsTableHeaderRow from "./VsTableHeaderRow.vue";
  import BaseService from "./api/BaseService.js";
  import Utils from "../_framework/utils/Utils.js";
  import EventBus from "./bus.js";
  import * as $ from "jquery";
  import VsTableMixin from "./VsTableMixin";
  import {mapState} from "vuex";

  export default {
    name: "vs-table",
    components: {
      VsTableRow,
      VsTableHeaderRow
    },
    props: {
      params: {
        default() {
          return {
            reqUrl: "",
            entity: "",
            extraParameters: "",
            headers: {}
          };
        },
        type: Object,
        showPaste: false,
      },
      options: {
        default() {
          return this.optionDefaults;
        },
        type: Object
      }
    },
    data() {
      return {
        isLoading: false,
        currentPage: 1,
        myshowPaste: false,
        optionDefaults: {
          tableHeight: null,
          createActionPosition: "top",
          autoLoad: true,
          clickableRows: false,
          clearStoreOnMount: false,
          dataSourceType: "api",
          isEditable: true,
          isPrintable: false,
          hasActions: true,
          onCreateHeaderActionClicked: false,
          headerActionsMode: "edit",
          deleteEntityAction: "delete",
          hasActionsInHeader: false,
          getTopRightButtons: () => {
            return [];
          },
          getTopLeftButtons: () => {
            return [];
          },
          beforeFetchEntityList: () => {
            return [];
          },
          fetchParams: {},
          innerBox: {}
        },
        pagination: {
          pageIndex: 0,
          pageSize: 12
        },
        list: {
          data: [],
          count: 0,
          entityMetaData: {}
        },
        searchParams: {},
        showSearchRow: false
      };
    },
    mounted() {
      if (this.getOptionValue("autoLoad")) {
        this.onFetchEntityListRequested({});
      }
      if (this.getOptionValue("clearStoreOnMount") === true) {
        this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
      }

      // this.myshowPaste = this.params.showPaste;
    },
    mixins: [VsTableMixin],
    methods: {
      onTableSearchInputChanged(event) {
        this.$nextTick(() => {
          let value = event.target.value;
          if (value === this.lastValue) {
            return;
          }
          this.$emit("onTableSearchInputChanged", value);
          this.onSearchInputDataChanged("name", value);
        });
      },
      onCreateHeaderActionClicked(headers) {
        this.$emit("onCreateHeaderActionClicked", headers);
      },
      getHeaderFormsInput() {
        return this.$refs.headerFormsRow.input;
      },
      onToggleHeaderForms() {
        EventBus.$emit("toggleHeaderForms");
      },
      onPaginationChange(pageIndex) {
        if (pageIndex) {
          this.pagination.pageIndex = pageIndex - 1;
        }
      },
      onFetchEntityListRequested(input = {}) {
        if (this.options != null && this.options.beforeFetchEntityList) {
          this.onFetchEntityList(this.options.beforeFetchEntityList(input, this));
        } else {
          this.onFetchEntityList(input);
        }
      },
      onFetchEntityList(input) {
        // merge pagination values (from this component) and user provided parameters into one object (overwrite)
        if (this.getOptionValue("dataSourceType") === "store") {
          this.fetchListFromStore();
        } else {
          this.fetchListFromAPI(input);
        }
      },
      fetchListFromStore() {
        this.list.data = this.vsTableFeed;
      },
      fetchListFromAPI(input) {
        this.pagination = Object.assign({}, this.params.extraParameters, this.pagination, input);
        // console.log(this.pagination );
        // console.log(this.params.entity);
        this.isLoading = true;
        new BaseService(this.params.entity, this.params.reqUrl)
          .getList(this.pagination)
          .then(response => {
            // console.log(response.data);
            this.isLoading = false;
            if (response.data) {
              // console.log("map");
              // console.log(response.data.data);
              // this.list = [];
              if (response.data.count === undefined || response.data.data === null) {
                this.list.count = response.data.length;
                this.list.data = response.data;
              } else {
                this.list.count = response.data.count;
                this.list.data = response.data.data;
              }
              // console.log(this.list);

            } else {
              // console.log("nomap");
              this.list = [];
              setTimeout(() => {
                this.list = response.data.data;
                this.list.count = response.data.count;
              }, 50)
            }
            // console.log(this.list.data);
            // console.log(this.list.count);
          });
      },
      onCreateEntityRequested(input = {}) {
        if (this.options.beforeCreateEntity) {
          let res = this.options.beforeCreateEntity(input, this);
          if (res === null) {
            return;
          }
          this.onCreateEntity(res);
        } else {
          this.onCreateEntity(input);
        }
      },
      onCreateEntity(input) {
        if (this.getOptionValue("dataSourceType") === "store") {
          this.onCreateEntityFromStore(input);
        } else {
          this.onCreateEntityFromAPI(input);
        }
      },
      onCreateEntityFromStore(input) {
        try {
          let inputCopy = JSON.parse(JSON.stringify(input));
          this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", inputCopy);
          EventBus.$emit("onResetRowMode");
        } catch (e) {
          console.log(
            "Error happened. Probably safe to ignore. Line VsTable@onCreateEntityFromStore"
          );
        }
      },
      onCreateEntityFromAPI(input) {
        new BaseService(this.params.entity).create(input).then(response => {
          this.$noty.success("با موفقیت انجام شد.");
          this.onFetchEntityListRequested();
          EventBus.$emit("onResetRowMode");
        });
        // .catch(error => {
        //   let message =
        //     error.response && error.response.data
        //       ? error.response.data
        //       : error.data.message;
        //   if (
        //     error &&
        //     error.data &&
        //     error.data.errors &&
        //     error.data.errors.length > 1
        //   ) {
        //     error.data.errors.map(er => {
        //       message = er.message;
        //       Utils.handleErrorWithNotification(message, this.$noty);
        //     });
        //   } else {
        //     Utils.handleErrorWithNotification(message, this.$noty);
        //   }
        // });
      },
      onDeleteEntityRequested(input = {}) {
        if (this.options != null && this.options.beforeDeleteEntity) {
          let res = this.options.beforeDeleteEntity(input, this);
          if (res === null) {
            return;
          }
          this.onDeleteEntity(res);
        } else {
          this.onDeleteEntity(input);
        }
      },
      onDeleteEntity(input) {
        if (this.getOptionValue("dataSourceType") === "store") {
          this.onDeleteEntityFromStore(input);
          this.onFetchEntityListRequested();
        } else {
          this.onDeleteEntityFromAPI(input);
        }
      },
      onDeleteEntityFromAPI(input) {
        new BaseService(this.params.entity).delete(input.id).then(response => {
          this.$noty.warning("با موفقیت حذف شد.");
          this.onFetchEntityListRequested();
        });
        // .catch(error => {
        //   if (
        //     error.response !== undefined &&
        //     error.response.data !== undefined
        //   ) {
        //     Utils.handleErrorWithNotification(error.response.data, this.$noty);
        //   } else if (error.data && error.data.message !== undefined) {
        //     Utils.handleErrorWithNotification(error.data, this.$noty);
        //   } else {
        //     Utils.handleErrorWithNotification("خطا.", this.$noty);
        //   }
        // });
      },
      onDeleteEntityFromStore(input) {
        this.$store.commit("DELETE_ROW_FROM_VS_TABLE_FEED", input.id);
      },
      onUpdateEntityRequested(input = {}) {
        if (this.options.beforeUpdateEntity) {
          let res = this.options.beforeUpdateEntity(input, this);

          if (res === null) {
            return;
          }
          this.onUpdateEntity(res);
        } else {
          this.onUpdateEntity(input);
        }
      },
      onUpdateEntity(input) {
        if (this.getOptionValue("dataSourceType") === "store") {
          this.onUpdateEntityFromStore(input);
          this.onFetchEntityListRequested();
        } else {
          this.onUpdateEntityFromAPI(input);
        }
      },
      onUpdateEntityFromStore(input) {
        try {
          let inputCopy = JSON.parse(JSON.stringify(input));
          let index = this.vsTableFeed.findIndex((el, index, arr) => {
            return el.id === inputCopy.id;
          });

          this.$store.commit("REPLACE_ROW_IN_VS_TABLE_FEED", {
            row: inputCopy,
            key: index
          });
          EventBus.$emit("onResetRowMode");
        } catch (e) {
          console.log(
            "Error happened. Probably safe to ignore. Line VsTable@onUpdateEntityFromStore"
          );
        }
      },
      onUpdateEntityFromAPI(input) {
        new BaseService(this.params.entity).update(input).then(response => {
          this.$noty.success("با موفقیت تغییر یافت.");
          this.onFetchEntityListRequested();
          EventBus.$emit("onResetRowMode");
        });
        // .catch(error => {
        //   Utils.handleErrorWithNotification(error.response.data, this.$noty);
        // });
      },
      onRowClickedHandler(row) {
        if (this.options.onRowClicked) {
          this.options.onRowClicked(row);
        }
      },
      onRowDoubleClickedHandler(row) {
        if (this.options.onRowDoubleClicked) {
          this.options.onRowDoubleClicked(row);
        }
      },
      onEditClickedHandler(row) {
        if (this.options.onEditClicked) {
          this.options.onEditClicked(row, this);
        }
      },
      onPrintClickedHandler(row) {
        if (this.options.onEditClicked) {
          this.options.onPrintClicked(row);
        }
      },
      onPasteClickedHandler(row) {
        if (this.options.onPasteClicked) {
          this.options.onPasteClicked(row, this);
        }
      },
      onSearchInputDataChanged(headerKey, val) {
        this.searchParams[headerKey] = val;

        this.onFetchEntityListRequested(this.searchParams);
      },
      onToggleSearchRow() {

        if(this.$refs.searchRow.style.display === ''){
          this.searchParams["name"] = "";
          this.onFetchEntityListRequested(this.searchParams);
        }
        $(this.$refs.searchRow).slideToggle(200);
      }
    },
    watch: {
      "pagination.pageIndex": function (val) {
        this.onFetchEntityListRequested({});
      }
    },
    computed: {
      ...mapState(["selectedRows", "vsTableFeed"]),
      searchableHeaders() {
        let headers = [];
        for (let obj in this.params.headers) {
          if (
            this.params.headers[obj].isSearchable !== undefined &&
            this.params.headers[obj].isSearchable === true
          ) {
            let item = this.params.headers[obj];
            item.key = obj;
            headers.push(this.params.headers[obj]);
          }
        }

        return headers;
      }
    }
  };
</script>

<style scoped lang="scss">
  .table thead th {
    border-bottom: none;
  }

  h5.no-data-note {
    margin: 1rem;
  }

  .row.top-buttons > * {
    margin-right: 1rem;
  }

  .top-border-for-bottom-forms {
    border-top: 1px solid #2f296b;
  }

  .vs-table-content-container {
    display: block;
  }

  @import "./VsTable.scss";
</style>
